import gql from 'graphql-tag';
import qs from 'qs';

let graphqlClient;

const recordDataPoint = gql`
  mutation recordDataPoint($name: String!, $data: JSON!, $eventId: String) {
    recordDataPoint(input: { name: $name, data: $data, eventId: $eventId })
  }
`;

function init(client) {
  graphqlClient = client;
}

function getCookieCampaign() {
  return getCookieByKey('campaign');
}

function getLocalStorageCampaign(eventId) {
  return getLocalStorageByKey(`campaign_${eventId}`);
}

function getUUID() {
  return getCookieByKey('uuid');
}

function getCookieByKey(key) {
  const cookies = document.cookie.split('; ');

  for (let i = 0; i < cookies.length; i++) {
    let cookiePair = cookies[i].split('=');
    if (cookiePair[0] === key) {
      return cookiePair[1];
    }
  }
}

function getLocalStorageByKey(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return '';
  }
}

async function record(name, data = {}, eventId, isRegisterStandalone = false) {
  if (!graphqlClient) {
    throw new Error('Graphql client not set, please start the analytics first!');
  }

  const urlReferrer = qs.parse(window.location.search, { ignoreQueryPrefix: true }).referrer;
  const referrer = isRegisterStandalone ? urlReferrer : document.referrer;

  const successful = await graphqlClient.mutate({
    mutation: recordDataPoint,
    variables: {
      eventId,
      name,
      data: {
        ...data,
        referrer,
        url: document.URL,
        uuid: getUUID(),
      },
    },
  });

  return successful;
}

export default { getUUID, getCookieCampaign, getLocalStorageCampaign, record, init };



// WEBPACK FOOTER //
// ./src/site-render/src/lib/analytics.js